import { Component, computed } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-textarea-type',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    TextareaModule
  ],
  templateUrl: './textarea-type.type.html',
  styleUrl: './textarea-type.type.scss',
})
export class TextareaType extends FieldType<FieldTypeConfig> {

  get currentLength(): number {
    return this.formControl.value?.length || 0;
  }

  get maxLength(): number | undefined {
    return this.props.maxLength;
  }

  get counterText(): string {
    if (!this.maxLength) return '';
    return `${this.currentLength}/${this.maxLength} caracteres.`;
  }

  get validationMessage(): string | undefined {
    return this.field.validation?.messages?.['maxLength'] as string | undefined;
  }

  get isOverLimit(): boolean {
    return this.maxLength ? this.currentLength > this.maxLength : false;
  }
}
